/**
 * Resolve a server-relative path against the server's base URL, preserving any
 * deployment subpath.
 *
 * `new URL('/api/workspaces/x', 'https://host/mindmap')` returns
 * `https://host/api/workspaces/x` — a leading slash discards the base's path.
 * When AFFiNE is mounted under a subpath (AFFINE_SERVER_SUB_PATH) that silently
 * sends every request to the domain root, which on a shared host belongs to a
 * different app. Resolving relative to the base keeps the subpath intact.
 */
export function resolveServerUrl(input: string, serverBaseUrl: string): URL {
  const base = serverBaseUrl.endsWith('/')
    ? serverBaseUrl
    : `${serverBaseUrl}/`;
  const path = input.startsWith('/') ? input.slice(1) : input;
  return new URL(path, base);
}
